import React from 'react'

export default function HelpButton(props){
	return(
		<button
			className={"header-button"}
			onClick={props.clickFunc}
		>
			Help
		</button>
	)
}